export const config = {
    entityKey: 'contacts',
    titles: {
        singular: 'Contact',
        plural: 'Contacts'
    }
}